module.exports = __webpack_public_path__ + "static/media/notes3.bb799345.png";